// @flow
import { Record } from 'immutable';
import type { RecordFactory } from 'immutable';

type UndoProps = {
  key: string,
  actions: Object,
  userMessage: string,
};

export const mkUndo: RecordFactory<UndoProps> = Record({
  key: undefined,
  actions: undefined,
  userMessage: undefined,
});
